import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import { Wallet, WalletState, UserWallet } from './types';
import { RootState } from '../types';
import tradingService from '@/services/tradingService';
import store from '@/store';
import walletService from '@/services/walletService';

const state: WalletState = {
  wallet: null,
  user_wallet: null,
};

const mutations: MutationTree<WalletState> = {
  SET_WALLET(state: WalletState, wallet: Wallet) {
    state.wallet = wallet;
  },
  SET_USER_WALLET(state: WalletState, user_wallet: UserWallet) {
    state.user_wallet = user_wallet;
  },
};

const getters: GetterTree<WalletState, RootState> = {
  wallet: (state: WalletState) => state.wallet,
  userWallet: (state: WalletState) => state.user_wallet,
};

const actions: ActionTree<WalletState, RootState> = {
  async fetchWallet({ commit }: { commit: Function, rootState: any }) {
    store.dispatch('appState/startLoader');

    try {
      await store.dispatch('wallet/fetchWalletUser');

      const walletResponse = await tradingService.getUserWallet();
      commit('SET_WALLET', walletResponse.data);
      store.dispatch('appState/stopLoader');

      return walletResponse;
    } catch(error) {
      store.dispatch('appState/stopLoader');

      return Promise.reject(error);
    }
  },

  async fetchWalletUser({ commit }: { commit: Function, rootState: any }) {
    
    try {
      const walletResponse = await walletService.getUser();
      commit('SET_USER_WALLET', walletResponse);

      return walletResponse;
    } catch(error) {

      return Promise.reject(error);
    }
  },
};

export const wallet: Module<WalletState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
